(() => {
  const config = document.getElementById('AloeMinimumOrder');
  if (!config) return;

  const minimum = Number(config.dataset.minimum) || 5;
  const actionSelector = '.request-quote-btn, button[name="checkout"], input[name="checkout"]';
  let violations = [];
  let refreshTimer;

  const getViolations = (cart) => {
    const products = new Map();

    for (const item of cart.items || []) {
      if (item.handle === 'dtf-meterbogen-560x1000') continue;
      const current = products.get(item.product_id) || { title: item.product_title, quantity: 0 };
      current.quantity += item.quantity;
      products.set(item.product_id, current);
    }

    return [...products.values()].filter((product) => product.quantity < minimum);
  };

  const getMessage = () => {
    const items = violations
      .map((product) => `${product.title} (${product.quantity}/${minimum})`)
      .join(', ');
    return `${config.dataset.message} ${config.dataset.item}: ${items}`;
  };

  const getNotice = (action) => {
    let notice = action.previousElementSibling;
    if (!notice?.classList.contains('aloe-minimum-order-notice')) notice = null;

    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'aloe-minimum-order-notice';
      notice.setAttribute('role', 'alert');
      notice.setAttribute('aria-live', 'polite');
      notice.tabIndex = -1;
      action.insertAdjacentElement('beforebegin', notice);
    }

    return notice;
  };

  const updateActions = () => {
    const invalid = violations.length > 0;
    document.documentElement.classList.toggle('aloe-minimum-order-invalid', invalid);

    document.querySelectorAll(actionSelector).forEach((action) => {
      const notice = getNotice(action);
      const message = invalid ? getMessage() : '';
      if (notice.textContent !== message) notice.textContent = message;
      if (notice.hidden === invalid) notice.hidden = !invalid;

      if (invalid) {
        action.dataset.aloeMinimumDisabled = 'true';
        action.disabled = true;
        action.setAttribute('aria-disabled', 'true');
      } else if (action.dataset.aloeMinimumDisabled === 'true') {
        delete action.dataset.aloeMinimumDisabled;
        action.disabled = false;
        action.removeAttribute('aria-disabled');
      }
    });
  };

  const refresh = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Cart could not be loaded');
      violations = getViolations(await response.json());
      updateActions();
    } catch (error) {
      console.error(error);
    }
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 150);
  };

  document.addEventListener(
    'click',
    (event) => {
      const action = event.target.closest(actionSelector);
      if (action && violations.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        getNotice(action).focus({ preventScroll: false });
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const action = event.submitter;
      if (action && action.matches(actionSelector) && violations.length > 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleRefresh);
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  }

  new MutationObserver(updateActions).observe(document.body, { childList: true, subtree: true });
  refresh();
})();
